import { isProbablyEscenicId } from 'app/utils/contentoUtils';
import { useRouter } from 'next/router';
import React from 'react';
import { VideoEntry } from '../../../app/components/DetailsPage/VideoEntry';

const VideoPage = () => {
    const router = useRouter();

    const isTitle = !isProbablyEscenicId(router.query.videoId);

    return <VideoEntry videoId={router.query.videoId} isTitle={isTitle} />;
};

export default VideoPage;
